/* Card Slider */
'use strict';

(function ($, Drupal) {
  Drupal.behaviors.CardSlider = {
    attach: function () {
      $('.card-slides').each(function () {
        var id = $(this).attr('data-slider-id');
        $(this).slick({
          nextArrow: '.card-slides-control[data-slider-control-id="' + id + '"] .next',
          prevArrow: '.card-slides-control[data-slider-control-id="' + id + '"] .prev',
        });
      });
    }
  };
})(jQuery, Drupal);
